var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forward-message-sidebar"},[_c('number-input',{staticClass:"mt-0",attrs:{"setup":{
      'func': _vm.setFailTryMaxCount,
      'args': {
        'model': _vm.node.data,
        'key': 'fail_try_max_count',
        'prefix': 'flow_forward_message_sidebar_',
        'min': 0,
        'validation': 'required',
      }
    }}}),_c('select-input',{attrs:{"setup":{
      'func': _vm.setMode,
      'args': {
        'model': _vm.node.data,
        'key': 'mode',
        'multiple': false,
        'clearable': false,
        'options': _vm.modeOptions,
        'prefix': 'flow_forward_message_sidebar_',
      }
    }}}),_c('config-field',{attrs:{"title":_vm.$t('field_flow_forward_message_sidebar_targets_title')}},[_c('ul',{staticClass:"flex flex-col gap-2"},_vm._l((_vm.beautifiedTargets),function(item,index){return _c('li',{key:index},[_c('target-card',{attrs:{"target":item,"has-delete-button":""},on:{"delete-click":function($event){return _vm.node.removeTarget(item.id)}}})],1)}),0)]),_c('a-auto-complete',{staticClass:"target-search w-full mr-2",on:{"select":_vm.selectOption},model:{value:(_vm.targetId),callback:function ($$v) {_vm.targetId=$$v},expression:"targetId"}},[_c('template',{slot:"dataSource"},[(_vm.filteredTargets.length)?_c('a-select-opt-group',{key:_vm.$t('flow_forward_message_sidebar_targets_group_targets')},_vm._l((_vm.filteredTargets),function(opt){return _c('a-select-option',{key:opt.value,attrs:{"value":opt.value.toString()}},[_vm._v(" "+_vm._s(opt.label)+" ")])}),1):_vm._e(),(_vm.filteredAdmins.length)?_c('a-select-opt-group',{key:_vm.$t('flow_forward_message_sidebar_targets_group_users')},_vm._l((_vm.filteredAdmins),function(opt){return _c('a-select-option',{key:opt.value,attrs:{"value":opt.value.toString()}},[_vm._v(" "+_vm._s(opt.label)+" ")])}),1):_vm._e()],1),_c('a-input',{staticClass:"help",on:{"pressEnter":function($event){return _vm.addTarget()}}},[_c('a-button',{staticClass:"-mr-3",attrs:{"slot":"suffix","icon":"plus","disabled":!_vm.targetId},on:{"click":function($event){return _vm.addTarget()}},slot:"suffix"},[_vm._v(" "+_vm._s(_vm.$t('add'))+" ")])],1)],2),_c('new-multi-message-editor-with-media-input',{staticClass:"mb-0",attrs:{"setup":{
      'func': _vm.setFailMessage,
      'args': {
        'model': _vm.node.data,
        'key': 'fail_message',
        'validation': 'required',
        'pinButtons': true,
        'hasMedia': true,
        'prefix': 'flow_forward_message_sidebar_',
        'targetToUpload': {
          'target': 'target',
          'target_id': _vm.node.nodeProps.target,
        },
        'customMediaTypes': _vm.node.nodeProps.customMediaTypes,
      }
    }}}),_c('a-card',{attrs:{"size":"small","body-style":{ padding: '0.25rem' }}},[_c('mini-help-message',{staticClass:"px-2",attrs:{"message":_vm.$t('flow_forward_message_min_max_message_length_mini_help_message').toString()}}),_c('div',{class:_vm.isMobile() ? '' : 'flex'},[_c('number-input',{attrs:{"setup":{
          'func': _vm.setMinLength,
          'args': {
            'model': _vm.node.data,
            'key': 'min_length',
            'min': 0,
            'inline': _vm.isMobile(),
            'prefix': 'flow_forward_message_sidebar_',
          }
        }}}),_c('number-input',{attrs:{"setup":{
          'func': _vm.setMaxLength,
          'args': {
            'model': _vm.node.data,
            'key': 'max_length',
            'min': 0,
            'inline': _vm.isMobile(),
            'prefix': 'flow_forward_message_sidebar_',
          }
        }}})],1)],1),_c('switch-input',{attrs:{"setup":{
      'func': _vm.setRegexObj,
      'args': {
        'model': _vm.node,
        'key': 'hasRegex',
        'prefix': 'flow_forward_message_sidebar_',
      }
    }}}),_c('transition-group',{attrs:{"name":"default-hide","mode":"out-in"}},[(_vm.node.data.regex)?[_c('text-input',{key:((_vm.node.id) + "-regex-pattern"),attrs:{"setup":{
          'func': _vm.setPattern,
          'args': {
            'model': _vm.node.data.regex,
            'key': 'pattern',
            'prefix': 'flow_forward_message_sidebar_',
          }
        }}}),_c('switch-input',{key:((_vm.node.id) + "-regex-invert"),attrs:{"setup":{
          'func': _vm.setInvert,
          'args': {
            'model': _vm.node.data.regex,
            'key': 'invert',
            'prefix': 'flow_forward_message_sidebar_',
          }
        }}})]:_vm._e()],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }